/**
 * 多分辨率适配混入
 * 用于屏幕分辨率变化时，自动更新尺寸变量，主要用在必须在代码中使用尺寸变量的情况，例如ECharts
 * 如何使用：
 * 先引入该混入，再在代码中定义adaptationVarsDefine选项，再列出尺寸变量的值。
 * 例如：
 * export default {
 *   adaptationVarsDefine: {
 *     width: 100
 *   }
 * }
 * 然后可以直接用以下方式使用该变量
 * export default {
 *   watch: {
 *     adaptationVars: function (val) {
 *       val.width ...
 *     }
 *   },
 *   methods: {
 *     someFunctions: function() {
 *       this.adaptationVars.width
 *     }
 *   }
 * }
 * 
 * 注意：
 * 在adaptationVars中可以获取当前窗口的实际宽度和高度
 * export default {
 *   data() {
 *     return {
 *       adaptationVars: {
 *          $windowWidth: ... //窗口宽度
 *          $windowHeight: ... //窗口高度
 *       }
 *     }
 *   }
 * }
 */
export default {
  name: 'Adaptation',
  data() {
    return {
      adaptationVars: {}
    }
  },
  created() {
    window.addEventListener('resize', this.onWindowResize)
    this.resetDisplayViewSize(document.body.clientWidth, document.body.clientHeight)
  },
  mounted() {
    this.resetDisplayViewSize(document.body.clientWidth, document.body.clientHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    onWindowResize: function(event) {
      this.resetDisplayViewSize(document.body.clientWidth, document.body.clientHeight)
    },
    resetDisplayViewSize: function(w, h) {
      if (this.$options.adaptationVarsDefine) {
        let r = {}
        let designWidth = 1440
        let ratio = 1
        if (w > designWidth) {
          ratio = (Math.floor((w - designWidth) / (designWidth / 2))) * 0.25 + 1
        }
        for (var item in this.$options.adaptationVarsDefine) {
          r[item] = this.$options.adaptationVarsDefine[item] * ratio
        }
        this.adaptationVars = r
        this.adaptationVars.$windowHeight = h
        this.adaptationVars.$windowWidth = w
      }
    }
  }
}
